module.exports = __webpack_public_path__ + "static/media/lamp.5731de2f.jpg";